import { render } from "./Instrument.vue?vue&type=template&id=3ebb9fe6"
import script from "./Instrument.vue?vue&type=script&lang=js"
export * from "./Instrument.vue?vue&type=script&lang=js"
script.render = render

export default script